export const langPickerControll = classNames => {
  $(classNames).each(function () {
    const $picker = $(this);
    let menuOpened = false;

    $picker.off('click').on('click', function (e) {
      if ($(e.target).closest('.sub_chooser').length) return;
      menuOpened = !menuOpened;
      $picker.toggleClass('menuOpened', menuOpened);
    });

    $picker.find('.chooser > li').each(function () {
      const $li = $(this);
      if ($li.find('.sub_chooser').length) {
        $li.off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          $li.toggleClass('opened');
        });

        $li.find('.sub_chooser a').each(function () {
          $(this).off('click').on('click', function (e) {
            e.stopPropagation();
            window.location.href = $(this).attr('href');
            menuOpened = false;
            $picker.removeClass('menuOpened');
          });
        });
      }
    });
  });

  $(document).off('click.langPicker').on('click.langPicker', function (e) {
    if (!$(e.target).closest(classNames).length) {
      $(classNames).removeClass('menuOpened');
    }
  });
};